<div class="main-titles" *ngIf="page" [innerHTML]="page.content"></div>
